module.exports = __webpack_public_path__ + "static/media/Site_Boston.9f4b0dae.jpg";